import { render } from "./PosOrderReceiptComponent.vue?vue&type=template&id=451f37c0"
import script from "./PosOrderReceiptComponent.vue?vue&type=script&lang=js"
export * from "./PosOrderReceiptComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/posOrders/PosOrderReceiptComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "451f37c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('451f37c0', __exports__)) {
    api.reload('451f37c0', __exports__)
  }
  
  module.hot.accept("./PosOrderReceiptComponent.vue?vue&type=template&id=451f37c0", () => {
    api.rerender('451f37c0', render)
  })

}


export default __exports__